import SecureLS from 'secure-ls';

const ls = new SecureLS();

export const saveToStorage = (id: string, value: unknown): void => {
  ls.set(id, JSON.stringify(value));
};

export const getFromStorage = (id: string, defaultValue: unknown): any => {
  const fromStorage = ls.get(id);
  return fromStorage ? JSON.parse(fromStorage) : defaultValue;
};

export const removeFromStorage = (id: string): void => {
  ls.remove(id);
};
